import { cn } from "@/utils/utils";

export interface TLogoProps {
    className?: string;
    variant?: "default" | "white";
    size?: "sm" | "md" | "lg";
    /** Custom logo URL. If provided, displays the custom logo instead of the Proda logo */
    src?: string;
    /** Alt text for the logo. Defaults to "PRODA" if not provided */
    alt?: string;
}

const sizeMap = {
    sm: { width: 100, height: 28 },
    md: { width: 140, height: 39 },
    lg: { width: 200, height: 56 },
};

/**
 * Logo Component
 *
 * Displays a logo image. By default shows the PRODA logo,
 * but can display a custom logo when `src` is provided.
 */
export function Logo({ className, variant = "default", size = "md", src, alt }: TLogoProps) {
    const dimensions = sizeMap[size];
    const logoSrc = src || "/proda-logo.svg";
    const logoAlt = alt || "PRODA";

    return (
        <img
            src={logoSrc}
            alt={logoAlt}
            width={dimensions.width}
            height={dimensions.height}
            className={cn(
                "flex-shrink-0 object-contain",
                variant === "white" && !src && "brightness-0 invert",
                className,
            )}
        />
    );
}
